import { l } from '../lib/imports'
import { scene } from '../main/scene-sidecar'
import { pathFinder } from './pathFinder-sidecar'
import { IPathHighlight } from './pathHighlights'
import { pathHighlights } from './pathHighlights-sidecar'

let highlights: IPathHighlight[] = []

export type PathSpotType = { x: number; y: number }

export type PathType = PathSpotType[]

let lastNumber = 0
export const findPath = (
  sx: number,
  sy: number,
  ex: number,
  ey: number,
  isInsideShip: boolean,
  allowNextTo: boolean,
  callback?: (path: PathType) => void,
) => {
  pathFinder.findPath(sx, sy, ex, ey, isInsideShip, allowNextTo, (path) => {
    lastNumber = 0
    // console.log('found path!', path)

    highlightPath(path)

    if (callback) {
      callback(path)
    }
  })
}

export const highlightPath = (path: PathType | null) => {
  clearHighlight()

  if (path) {
    let ctx = scene.getContext()
    for (let i = 0; i < path.length; i++) {
      let c = path[i]
      let h = pathHighlights.create()
      pathHighlights.moveToTile(h, ctx.mapShip, c.x, c.y)
      pathHighlights.setRotation(h, path[i], path[i + 1])
      highlights.push(h)
    }
  }
}

export const clearHighlight = () => {
  l.forEach(highlights, (c) => {
    pathHighlights.kill(c)
  })
}
